module.exports = __webpack_public_path__ + "img/no_zone.9881f370.svg";